import '.d{display:flex;}.ssr-plugin'
import '.ad{align-items:stretch;}.ssr-plugin'
import '.a9{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.d6{background:var(--palette-white);}.ssr-plugin'
import '.ay{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.am{max-width:77.5rem;}.ssr-plugin'
import '.fg{justify-content:stretch;}.ssr-plugin'
import '.b9{position:sticky;}.ssr-plugin'
import '.ba{top:0px;}.ssr-plugin'
import '.be{z-index:10;}.ssr-plugin'
import '.fz{padding-block:1rem;}.ssr-plugin'
import '.g0{height:3rem;}.ssr-plugin'
import '.bx{justify-content:space-between;}.ssr-plugin'
import '.cp{flex-wrap:wrap;}.ssr-plugin'
import '.g1{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.eu{margin-top:2rem;}.ssr-plugin'
import '.g2{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d ad a9 e d6"
      >
        <div className="ay d r a9 e"
        >
          <div className="am d e fg b9 ba be d6"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fz g0 d bx r cp"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="g1 d e ad eu g2 am"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
